export default "__VITE_ASSET__CCLoSUxx__"